import withType from 'components/common/hoc/withType'
import Appointment from '../../Appointment'

export default withType({
  type: 'AppointmentOneColumnPage', placeholders: ['header', 'mainContent', 'footer']
})(Appointment)
